import { render, staticRenderFns } from "./CaseNotesList.vue?vue&type=template&id=1ed606b1&scoped=true&"
import script from "./CaseNotesList.vue?vue&type=script&lang=js&"
export * from "./CaseNotesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed606b1",
  null
  
)

export default component.exports